import React from "react";

import { MembersListQueryRenderer } from "../../features/Club/components/Members/MembersListQueryRenderer";

export const Members = () => {
  return <MembersListQueryRenderer />;
};
